import type { SidebarMenuItem } from '@/layouts/sidebarMenuConfig';

/**
 * 사이드바 메뉴 active 판별.
 * `/admin/max-match/standard`와 `/admin/max-match/lite`처럼 형제 경로일 때
 * 더 구체적인 메뉴만 하이라이트한다. (한쪽이 다른 쪽 prefix인 경우도 동일)
 */
export const collectMenuPaths = (items: SidebarMenuItem[]): string[] => {
  const paths: string[] = [];
  for (const item of items) {
    if ('type' in item && item.type === 'divider') continue;
    if ('children' in item) {
      paths.push(...item.children.map((child) => child.key));
      continue;
    }
    if ('key' in item) {
      paths.push(item.key);
    }
  }
  return paths;
};

export const isMenuPathActive = (
  pathname: string,
  path: string,
  allMenuPaths: string[],
): boolean => {
  if (pathname === path) return true;
  if (!pathname.startsWith(`${path}/`)) return false;

  // 더 긴(구체적인) 메뉴 경로가 pathname에 매칭되면 짧은 경로는 inactive
  return !allMenuPaths.some(
    (other) =>
      other !== path &&
      other.startsWith(`${path}/`) &&
      (pathname === other || pathname.startsWith(`${other}/`)),
  );
};
